﻿import { Component, ViewChild } from '@angular/core';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { WarehouseDto } from 'src/app/dtos/warehouse-dto';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'warehouses',
    templateUrl: './warehouses.component.html',
    styleUrls: ['./warehouses.component.scss']
})

export class WarehousesComponent {
    search: any;
    @ViewChild("tableChild") tableChild: DataTableComponent<WarehouseDto>;
  pagePath: string = "api/warehouse/page";
  searchText: string = '';
  options = {
    columnTitles: ["WAREHOUSE.TABLE.ID", "WAREHOUSE.TABLE.NAME" , "WAREHOUSE.TABLE.PLANT", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'name', 'plantName', "actions"],
    actionButtons: { edit: true, delete: true }
  };

    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

    }

    goToEdit(e: any) {
      this.router.navigate(["warehouses/edit", e.id]);
    }

    openDeleteDialog(e: any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '680px',
          data: {
            title: 'DIALOGS.DELETE_WAREHOUSE.TITLE',
            body: 'DIALOGS.DELETE_WAREHOUSE.BODY',
            cancelButtonText: "GENERAL.LABELS.CANCEL",
            confirmButtonText: "GENERAL.LABELS.DELETE",
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.apiService.delete('api/warehouse/' + e.id).subscribe(data => {
              this.messageService.success("Exito", "El almacen fue removido exitosamente");
              this.tableChild.loadPage();
            }, error => {
              this.messageService.error("Error", error.message);
            })
          }
        });
      }

      searchWar(){
        this.search = {
            searchText: this.searchText
          }
          this.tableChild.firstPage();
          this.tableChild.loadPage(this.search);
    }

}